import { Box } from '@mui/material';
import React, { useMemo } from 'react';

import { TooltippedTruncatedText } from '~/components/TooltippedTruncatedText';
import { People } from '~/services/Http';

import { useSxStyles } from './useStyles';

export interface Props {
  title: string;
  listItems?: People.INotificationDto[];
}

export const MyNotificationsWidgetHeader: React.FC<Props> = ({
  title,
  listItems,
}) => {
  const sxStyles = useSxStyles();

  const unreadNotificationsNo = useMemo(
    () => listItems?.filter((li) => !li.isRead).length,
    [listItems],
  );

  return (
    <Box sx={sxStyles.root}>
      <TooltippedTruncatedText>{title}</TooltippedTruncatedText>
      {unreadNotificationsNo !== undefined && unreadNotificationsNo > 0 && (
        <Box sx={sxStyles.count}>({unreadNotificationsNo})</Box>
      )}
    </Box>
  );
};
